import { createSystem, defaultConfig } from '@chakra-ui/react';

const system = createSystem(defaultConfig, {
    theme: {
        tokens: {
            fonts: {
                heading: {
                    value: `'Figtree', sans-serif`,
                },
                body: {
                    value: `'Figtree', sans-serif`,
                },
            },

            colors: {
                brand: {
                    100: {
                        value: '#F7A600',
                    },
                    // ...
                    900: {
                        value: '#E14300',
                    },
                },
            },
        },
        semanticTokens: {
            colors: {
                brand: {
                    solid: { value: "{colors.brand.100}" },
                    contrast: { value: "{colors.brand.900}" },
                    fg: { value: "{colors.brand.900}" },
                    muted: { value: "{colors.brand.100}" },
                    subtle: { value: "{colors.brand.100}" },
                    emphasized: { value: "{colors.brand.900}" },
                    focusRing: { value: "{colors.brand.900}" },
                },
            },
        },
    },
});

// console.log(theme);

// white: #FFFFFF
// #gray1: #AFAFAF
// @gray2: 6c6c6c
// black: #000000

export default system;
